import React from "react";
import { Link } from "react-router-dom";
import Secure from "../assets/Secure-payment.gif";
import SearchInput from "./SearchInput";

const Section = () => {
  return (
    <div className="w-full text-[#333333] mb-8 py-2">
      <div className="max-w-[1240px] mx-auto grid md:grid-cols-3">
        <div
          data-aos="fade-right"
          data-aos-delay="600"
          data-aos-duration="1200"
          className="flex flex-col md:w-[400px]"
        >
          <div className="flex flex-col justify-center">
            <h1 className="md:text-lg font-semibold my-1 mx-auto">
              Welcome, what are you{" "}
              <span className="text-green-700">purchasing today?</span>{" "}
            </h1>
            <div className="flex mx-auto">
              <div>
                <Link to="/energy">
                  <button className="flex items-center justify-center bg-green-700 hover:bg-green-500 w-[60px] h-[60px] rounded-full text-white text-center my-2 mx-8">
                    <svg
                      width="21"
                      height="41"
                      viewBox="0 0 21 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.291626 0.0833435V22.5417H6.41663V40.9167L20.7083 16.4167H12.5416L20.7083 0.0833435H0.291626Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </Link>
                <p className="text-center text-xs">Electricity</p>
              </div>
              <div>
                <Link to="/airtime">
                  <button className="flex items-center justify-center bg-green-700 hover:bg-green-500 w-[60px] h-[60px] rounded-full text-white text-center my-2 mx-8">
                    <svg
                      width="34"
                      height="32"
                      viewBox="0 0 34 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.875 14.25C23.3792 14.25 22.9632 14.082 22.6272 13.746C22.2924 13.4112 22.125 12.9958 22.125 12.5C22.125 12.0042 22.2924 11.5882 22.6272 11.2522C22.9632 10.9174 23.3792 10.75 23.875 10.75C24.3708 10.75 24.7862 10.9174 25.121 11.2522C25.457 11.5882 25.625 12.0042 25.625 12.5C25.625 12.9958 25.457 13.4112 25.121 13.746C24.7862 14.082 24.3708 14.25 23.875 14.25ZM19.5 9.9625L17.6625 8.125C18.5083 7.27917 19.4638 6.62992 20.529 6.17725C21.593 5.72575 22.7083 5.5 23.875 5.5C25.0417 5.5 26.1576 5.72575 27.2227 6.17725C28.2867 6.62992 29.2417 7.27917 30.0875 8.125L28.25 9.9625C27.6667 9.37917 27.0034 8.92708 26.2602 8.60625C25.5159 8.28542 24.7208 8.125 23.875 8.125C23.0292 8.125 22.2341 8.28542 21.4897 8.60625C20.7466 8.92708 20.0833 9.37917 19.5 9.9625ZM15.825 6.2L13.9875 4.3625C15.3 3.05 16.8097 2.03617 18.5165 1.321C20.2222 0.607 22.0083 0.25 23.875 0.25C25.7417 0.25 27.5278 0.607 29.2335 1.321C30.9403 2.03617 32.45 3.05 33.7625 4.3625L31.925 6.2C30.8458 5.12083 29.6138 4.29658 28.229 3.72725C26.843 3.15908 25.3917 2.875 23.875 2.875C22.3583 2.875 20.9146 3.16667 19.5437 3.75C18.1729 4.33333 16.9333 5.15 15.825 6.2ZM29.9125 31.75C26.15 31.75 22.4826 30.9112 18.9102 29.2335C15.3367 27.557 12.1722 25.3403 9.4165 22.5835C6.65967 19.8278 4.443 16.6632 2.7665 13.0897C1.08883 9.51742 0.25 5.85 0.25 2.0875C0.25 1.5625 0.425 1.125 0.775 0.775C1.125 0.425 1.5625 0.25 2.0875 0.25H9.175C9.58333 0.25 9.94792 0.38125 10.2687 0.64375C10.5896 0.90625 10.7792 1.24167 10.8375 1.65L11.975 7.775C12.0333 8.18333 12.0263 8.55492 11.954 8.88975C11.8805 9.22575 11.7125 9.525 11.45 9.7875L7.25 14.075C8.475 16.175 10.0062 18.1437 11.8437 19.9812C13.6812 21.8187 15.7083 23.4083 17.925 24.75L22.0375 20.6375C22.3 20.375 22.643 20.1778 23.0665 20.046C23.4888 19.9153 23.9042 19.8792 24.3125 19.9375L30.35 21.1625C30.7583 21.25 31.0937 21.4466 31.3562 21.7522C31.6187 22.0591 31.75 22.4167 31.75 22.825V29.9125C31.75 30.4375 31.575 30.875 31.225 31.225C30.875 31.575 30.4375 31.75 29.9125 31.75Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </Link>
                <p className="text-center text-xs">Airtime</p>
              </div>
              <div>
                <Link to="/cable">
                  <button className="flex items-center justify-center bg-green-700 hover:bg-green-500 w-[60px] h-[60px] rounded-full text-white text-center my-2 mx-8">
                    <svg
                      width="36"
                      height="32"
                      viewBox="0 0 36 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.625 22.125L25.875 14.25L13.625 6.375V22.125ZM11 31.75V28.25H0.5V0.25H35.5V28.25H25V31.75H11Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </Link>
                <p className="text-center text-xs">Cable TV</p>
              </div>
            </div>
            <div className="flex mx-auto">
              <div>
                <Link to="/data">
                  <button className="flex items-center justify-center bg-green-700 hover:bg-green-500 w-[60px] h-[60px] rounded-full text-white text-center my-2 mx-8">
                    <svg
                      width="39"
                      height="39"
                      viewBox="0 0 39 39"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M34.5 30.75H38.25V15.75H34.5V30.75ZM34.5 38.25H38.25V34.5H34.5V38.25ZM0.75 38.25H30.75V12H38.25V0.75L0.75 38.25Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </Link>
                <p className="text-center text-xs">Internet</p>
              </div>
              <div>
                <Link to="/education">
                  <button className="flex items-center justify-center bg-green-700 hover:bg-green-500 w-[60px] h-[60px] rounded-full text-white text-center my-2 mx-8">
                    <svg
                      width="40"
                      height="32"
                      viewBox="0 0 40 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.9167 31.3333C21.9167 28.4264 21.3653 25.6951 20.2626 23.1396C19.1612 20.584 17.6521 18.3479 15.7355 16.4312C13.8188 14.5146 11.5827 13.0055 9.02712 11.9041C6.47157 10.8014 3.74032 10.25 0.833374 10.25V4.49999C0.833374 3.44582 1.20904 2.54371 1.96037 1.79366C2.71043 1.04232 3.61254 0.666656 4.66671 0.666656H35.3334C36.3875 0.666656 37.2903 1.04232 38.0416 1.79366C38.7917 2.54371 39.1667 3.44582 39.1667 4.49999V27.5C39.1667 28.5542 38.7917 29.4569 38.0416 30.2082C37.2903 30.9583 36.3875 31.3333 35.3334 31.3333H21.9167ZM14.25 31.3333C14.25 27.5958 12.9486 24.425 10.3458 21.8209C7.74168 19.2181 4.57087 17.9167 0.833374 17.9167V14.0833C3.22921 14.0833 5.47362 14.5382 7.56662 15.448C9.65835 16.359 11.4792 17.5889 13.0291 19.1376C14.5778 20.6875 15.8077 22.509 16.7187 24.602C17.6285 26.6937 18.0834 28.9375 18.0834 31.3333H14.25ZM6.58337 31.3333C6.58337 29.7361 6.02435 28.3785 4.90629 27.2604C3.78824 26.1424 2.4306 25.5833 0.833374 25.5833V21.75C3.48476 21.75 5.74451 22.684 7.61262 24.5522C9.48201 26.4215 10.4167 28.6819 10.4167 31.3333H6.58337ZM25.2709 15.6167L32.9375 11.2083L25.2709 6.79999L17.6042 11.2083L25.2709 15.6167ZM25.2709 21.4625L30.5417 18.3958V14.3708L25.2709 17.4375L20 14.3708V18.3958L25.2709 21.4625Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </Link>
                <p className="text-center text-xs">Education</p>
              </div>
              <div>
                <Link to="/bet">
                  <button className="flex items-center justify-center bg-green-700 hover:bg-green-500 w-[60px] h-[60px] rounded-full text-white text-center my-2 mx-8">
                    <svg
                      width="25"
                      height="13"
                      viewBox="0 0 25 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.816 0.575999C4.76533 0.575999 5.56 0.666666 6.2 0.848C6.85067 1.02933 7.336 1.328 7.656 1.744C7.98667 2.16 8.152 2.71467 8.152 3.408C8.152 3.856 8.06667 4.256 7.896 4.608C7.736 4.94933 7.49067 5.23733 7.16 5.472C6.84 5.696 6.44533 5.85067 5.976 5.936V6.016C6.456 6.09067 6.888 6.22933 7.272 6.432C7.66667 6.63467 7.976 6.92267 8.2 7.296C8.424 7.66933 8.536 8.15467 8.536 8.752C8.536 9.44533 8.376 10.0373 8.056 10.528C7.736 11.008 7.27733 11.376 6.68 11.632C6.09333 11.8773 5.38933 12 4.568 12H0.552V0.575999H3.816ZM4.104 5.44C5.08533 5.44 5.75733 5.28533 6.12 4.976C6.48267 4.656 6.664 4.18667 6.664 3.568C6.664 2.93867 6.44 2.49067 5.992 2.224C5.55467 1.94667 4.85067 1.808 3.88 1.808H1.992V5.44H4.104ZM1.992 6.64V10.784H4.296C5.30933 10.784 6.01333 10.5867 6.408 10.192C6.80267 9.79733 7 9.28 7 8.64C7 8.23467 6.90933 7.88267 6.728 7.584C6.55733 7.28533 6.264 7.056 5.848 6.896C5.44267 6.72533 4.888 6.64 4.184 6.64H1.992ZM14.1908 3.264C14.9268 3.264 15.5561 3.424 16.0788 3.744C16.6121 4.064 17.0175 4.51733 17.2948 5.104C17.5828 5.68 17.7268 6.35733 17.7268 7.136V7.984H11.8548C11.8761 8.95467 12.1215 9.696 12.5908 10.208C13.0708 10.7093 13.7375 10.96 14.5908 10.96C15.1348 10.96 15.6148 10.912 16.0308 10.816C16.4575 10.7093 16.8948 10.56 17.3428 10.368V11.6C16.9055 11.792 16.4735 11.9307 16.0468 12.016C15.6201 12.112 15.1135 12.16 14.5268 12.16C13.7161 12.16 12.9961 11.9947 12.3668 11.664C11.7481 11.3333 11.2628 10.8427 10.9108 10.192C10.5695 9.53067 10.3988 8.72533 10.3988 7.776C10.3988 6.83733 10.5535 6.032 10.8628 5.36C11.1828 4.688 11.6255 4.17067 12.1908 3.808C12.7668 3.44533 13.4335 3.264 14.1908 3.264ZM14.1748 4.416C13.5028 4.416 12.9695 4.63467 12.5748 5.072C12.1908 5.49867 11.9615 6.096 11.8868 6.864H16.2548C16.2548 6.37333 16.1801 5.94667 16.0308 5.584C15.8815 5.22133 15.6521 4.93867 15.3428 4.736C15.0441 4.52267 14.6548 4.416 14.1748 4.416ZM22.8866 11.008C23.1 11.008 23.3186 10.992 23.5426 10.96C23.7666 10.9173 23.948 10.8747 24.0866 10.832V11.904C23.9373 11.9787 23.724 12.0373 23.4466 12.08C23.1693 12.1333 22.9026 12.16 22.6466 12.16C22.1986 12.16 21.7826 12.0853 21.3986 11.936C21.0253 11.776 20.7213 11.504 20.4866 11.12C20.252 10.736 20.1346 10.1973 20.1346 9.504V4.512H18.9186V3.84L20.1506 3.28L20.7106 1.456H21.5426V3.424H24.0226V4.512H21.5426V9.472C21.5426 9.99467 21.6653 10.384 21.9106 10.64C22.1666 10.8853 22.492 11.008 22.8866 11.008Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </Link>
                <p className="text-center text-xs">Betting</p>
              </div>
            </div>
            {/* <div className='my-4'>
                   <SearchInput />
                </div> */}
          </div>
          <div className="flex flex-col justify-center border border-green-400 text-center rounded-lg mx-4 py-8 mt-8">
            <h1 className="md:text-sm ml-8  my-1 md:mx-4 font-medium">
            Hop on the opportunity to become a merchant on billerHQ
            </h1>
            <Link
              to="/getstarted"
              className="bg-green-700 hover:bg-green-500 text-white w-[250px] rounded-md font-medium mx-auto my-4 px-6 py-3 "
            >
              GET YOUR ACCOUNT
            </Link>
          </div>
        </div>

        <img
          data-aos="zoom-in-up"
          data-aos-delay="600"
          data-aos-duration="1200"
          className="w-[1000px] mx-auto my-4 md:col-span-2"
          src={Secure}
          alt="/"
        />
      </div>
    </div>
  );
};

export default Section;
